
export class WarningIcon {
    private readonly width = 29;
    private readonly height = 27;
    private ctx: CanvasRenderingContext2D;
    private readonly _rgbColor: string;

    data: Uint8ClampedArray = new Uint8ClampedArray(this.width * this.height * 4);

    constructor(rgbColor: string) {
        this._rgbColor = rgbColor;
    }

    public onAdd() {
        const canvas = document.createElement('canvas');
        canvas.width = this.width;
        canvas.height = this.height;
        this.ctx = canvas.getContext('2d', {
            willReadFrequently: true
        });
    }

    public render() {
        const ctx = this.ctx;
        
        // Create separate paths for better control
        const triangle = new Path2D('M14.484 2.0135C15.1995 2.0135 15.856 2.4075 16.1965 3.035L26.7045 22.4935C27.0305 23.097 27.016 23.827 26.6655 24.4155 26.3155 25.004 25.678 25.3645 24.9925 25.3645L3.9765 25.3645C3.2905 25.3645 2.6535 25.004 2.303 24.4155 1.953 23.827 1.938 23.097 2.264 22.4935L12.772 3.035C13.1125 2.4075 13.7695 2.0135 14.484 2.0135Z');
        
        // Separate paths for the "!" symbol parts
        const exclamationDot = new Path2D('M14.484 19.1375C13.623 19.1375 12.9275 19.833 12.9275 20.694 12.9275 21.555 13.623 22.2505 14.484 22.2505 15.345 22.2505 16.0415 21.555 16.0415 20.694 16.0415 19.833 15.345 19.1375 14.484 19.1375Z');
        const exclamationLine = new Path2D('M14.484 9.797C13.599 9.797 12.894 10.551 12.957 11.436L13.317 16.496C13.3605 17.1035 13.8715 17.5805 14.4795 17.5805 15.0925 17.5805 15.5985 17.1085 15.6425 16.496L16.002 11.436C16.0655 10.551 15.365 9.797 14.4745 9.797L14.484 9.797Z');

        ctx.save();
        
        // 1. Fill the triangle with the colored background
        ctx.fillStyle = this._rgbColor;
        ctx.fill(triangle);
        
        // 2. Add the black border around triangle
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 1;
        ctx.stroke(triangle);
        
        // 3. Fill the "!" symbol with black
        ctx.fillStyle = '#000';
        ctx.fill(exclamationDot);
        ctx.fill(exclamationLine);
        
        ctx.restore();

        this.data = ctx.getImageData(0, 0, this.width, this.height).data;

        return true;
    }
}